import React, { useRef, useState, useCallback, useEffect } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import useHandleActionClick from '../helpers/usehandleActionClick';
import { useSelector } from 'react-redux';
import TransactionMobileComponent from '../components/transactions/TransactionMobileComponent';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { fiatTransactions, cryptoTransactions } from '../helpers/constant';
import BalanceActionsPanel from '../components/singleBalance/BalanceActionsPanel';
import { MODAL_COMPONENTS } from '../helpers/constant';
import CryptoStatsMobile from '../components/cryptoBalance/CryptoStatsMobile';
import BalancesMobTabSection from '../components/singleBalance/BalancesMobTabSection';

const SingleBalancePage = () => {
    const { useWindowWidth, getTransactions } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();
    const navigate = useNavigate();
    const moreButtonRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [modalAction, setModalAction] = useState('');
    const kycStatus = useSelector(state => state.juno.clientData)?.kyc?.status;
    const handleActionClick = useHandleActionClick(kycStatus, setModalAction);
    const { getBalances, getSavedAccounts, getCryptoBalances, getCryptoData } =
        useJunoCommonFunctions();
    const clientData = useSelector(state => state.juno.clientData);
    const { balancesCurrencies, balancesCrypto } = useSelector(state => state.juno);
    const transactionsData = useSelector(state => state.juno.allTransactions);
    const activeCurrencyPage = useSelector(state => state.juno.activeCurrencyPage);

    const { currency } = useParams();
    const balancesData = [...balancesCurrencies, ...balancesCrypto];
    const currencyData = balancesData?.find(
        currencyData => currencyData.currencyShortName === currency,
    );

    const readOnly = clientData && clientData.readOnly ? clientData.readOnly : false;

    useEffect(() => {
        if (clientData) {
            activeCurrencyPage == 'fiat' && getBalances();
            activeCurrencyPage == 'crypto' && getCryptoBalances();
            getTransactions({ pageSize: 10, page: 1 });
            getSavedAccounts();
        }
    }, [clientData]);

    useEffect(() => {
        if (!menuOpen) return;

        const handleClickOutside = e => {
            if (moreButtonRef.current && !moreButtonRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [menuOpen]);

    const handleMoreClick = useCallback(e => {
        e.stopPropagation();
        setMenuOpen(prevOpen => !prevOpen);
    }, []);

    const actionIcons = activeCurrencyPage === 'fiat' ? fiatTransactions : cryptoTransactions;

    const handleCloseModal = useCallback(() => setModalAction(''), []);

    const commonModalProps = {
        open: true,
        onClose: handleCloseModal,
        row: currencyData,
        selectCurrency: true,
        isModal: true,
        type: modalAction,
        selectedBalance: currencyData,
        preSelected: currencyData,
    };
    const ModalComponent = MODAL_COMPONENTS[modalAction];

    const handleCloseMenu = useCallback(() => setMenuOpen(false), []);

    return (
        <div className="h-full bg-rootStyle-bg">
            {ModalComponent && <ModalComponent {...commonModalProps} />}
            <div className="h-[52px] relative bg-modal-bg rounded-bl-lg rounded-br-lg border-b  border-[#0000001F] dark:border-[#FFFFFF1F] mb-1">
                <div className="py-[14px] px-6 flex items-center justify-center relative">
                    <div className="absolute left-6" onClick={() => navigate(-1)}>
                        <ArrowBackIcon className=" !text-text" />
                    </div>
                    <p className="text-center text-base font-semibold !text-text uppercase">
                        {currencyData?.currencyFullName || currencyData?.currencyShortName}
                    </p>
                </div>
            </div>
            {activeCurrencyPage == 'crypto' && (
                <BalancesMobTabSection
                    currencyFullName={currencyData?.blockchain}
                    currencyShortName={currencyData?.currencyShortName}
                    balanceAmount={currencyData?.balanceAmount}
                    currencyIcon={currencyData?.currencyIcon}
                />
            )}
            <BalanceActionsPanel
                currencyData={currencyData}
                actionIcons={actionIcons}
                windowWidth={windowWidth}
                activeCurrencyPage={activeCurrencyPage}
                handleActionClick={handleActionClick}
                readOnly={readOnly}
                moreButtonRef={moreButtonRef}
                menuOpen={menuOpen}
                handleMoreClick={handleMoreClick}
                handleCloseMenu={handleCloseMenu}
            />
            {activeCurrencyPage !== 'fiat' && (
                <CryptoStatsMobile currency={currencyData?.currencyShortName} />
            )}
            {transactionsData?.length > 0 && (
                <div className="bg-modal-bg rounded-lg border-t   border-[#0000001F] dark:border-[#FFFFFF1F]">
                    <p className="justify-start text-section-title text-sm font-semibold pt-6 px-6 pb-2 uppercase">
                    {currencyData?.currencyFullName || currencyData?.currencyShortName} TRANSACTIONS
                    </p>
                    <TransactionMobileComponent
                        data={
                            windowWidth <= 640
                                ? transactionsData?.slice(0, 5)
                                : transactionsData?.slice(0, 10) || []
                        }
                        isDashboard={true}
                    />
                </div>
            )}
        </div>
    );
};

export default SingleBalancePage;
